import { render } from "../custom_service/custom_service.html?vue&type=template&id=183637ba&external"
import script from "../custom_service/custom_service.js?vue&type=script&lang=js&external"
export * from "../custom_service/custom_service.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__